socialUrls = require('locale').social
t = require('views/internal/teacup-with-helpers')('confirm_email')

FOOTER_LINKS = {
  "tour": "/tour"
  "pricing": "/pricing"
  "apps": "/platforms"
  "jobs": "/jobs"
  "blog": socialUrls.blog
  "developers": "https://developers.trello.com"
  "about": "/about"
  "help": "https://help.trello.com"
  "legal": "/legal"
}

module.exports = t.renderable ({ email }) ->
  t.a '.confirm-email-header', { href: "#" }, ->
    t.img '.js-logout', { src: require 'images/trello-logo-blue.svg' }
  t.div '.confirm-email-content', ->
    t.div ->
      t.img '.confirm-email-image', { src: require 'images/confirm-email-character.svg' }
      t.div '.confirm-email-text-body', ->
        t.h1 '.confirm-email-text-header', ->
          t.format 'check-your-email'
        t.p ->
          t.format 'we-sent-an-email-to-you-so-we-can-confirm-youre-you', { email }
          t.text " "
          t.format 'click-the-button-in-the-email-to-continue-on-your-way'
        t.p '.confirm-email-resend.js-show-resend-success.hide', ->
          t.icon 'check'
          t.text " "
          t.format 'email-sent'
        t.p '.confirm-email-resend.js-hide-resend-success', ->
            t.format 'cant-find-it-resend-email'
  t.div '.confirm-email-footer.quiet', ->
    t.div ->
      t.ul ->
        for text, link of FOOTER_LINKS
          t.li ->
            t.a { href: link }, ->
              t.format text
      t.div ->
        t.img { src: require 'images/atlassian-logo-gray-small.svg' }
        t.text " "
        t.format 'copyright-2018-all-rights-reserved'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/confirm_email.coffee